import dayjs from 'dayjs';

/**
 * Feedback endpoints treat endDate as an exclusive boundary. Advance it by a
 * day so the date selected in the UI remains inclusive for the user.
 */
export const toInclusiveFeedbackEndDate = (endDate: string) =>
  dayjs(endDate).add(1, 'day').format('MM/DD/YYYY');
